export const ORDER_EXCHANGE_STATUS = {
  AWAITING_CONFIRMATION: {
    value: 'AWAITING_CONFIRMATION',
    text: 'orderTrackingStatus.awaitingConfirmation',
    color: '#FFB300',
    background: '#FFB3001A',
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    text: 'orderTrackingStatus.confirmed',
    color: '#0075FF',
    background: '#0075FF1A',
  },
  RETURNING: {
    value: 'RETURNING',
    text: 'orderTrackingStatus.returning',
    color: '#FA541C',
    background: '#FA541C1A',
  },
  PROCESSING: {
    value: 'PROCESSING',
    text: 'Processing',
    color: '#AB2328',
    background: '#AB23281A',
  },
  COMPLETED: {
    value: 'COMPLETED',
    text: 'orderTrackingStatus.completed',
    color: '#66C11F',
    background: '#66C11F1A',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'orderTrackingStatus.cancelled',
    color: '#848484',
    background: '#8484841A',
  },
};

export const RETURN_STATUS = {
  AWAITING_APPROVAL: {
    value: 'AWAITING_APPROVAL',
    text: 'ordersExchange.status.awaitingApproval',
    color: '#FFB300',
    background: '#FFB3001A',
  },
  APPROVED: {
    value: 'APPROVED',
    text: 'ordersExchange.status.approved',
    color: '#0075FF',
    background: '#0075FF1A',
  },
  PASS_QC: {
    value: 'PASS_QC',
    text: 'ordersExchange.status.passedQC',
    color: '#FA541C',
    background: '#FA541C1A',
  },
  FAILED_QC: {
    value: 'FAILED_QC',
    text: 'ordersExchange.status.failedQC',
    color: '#AB2328',
    background: '#AB23281A',
  },
  COMPLETED: {
    value: 'COMPLETED',
    text: 'ordersExchange.status.completed',
    color: '#66C11F',
    background: '#66C11F1A',
  },
  CANCELLED: {
    value: 'CANCELLED',
    text: 'ordersExchange.status.canceled',
    color: '#848484',
    background: '#8484841A',
  },
};

export const WHO_PAY_SHIPPING_FEE = {
  CUSTOMER: {
    value: 'CUSTOMER',
    text: 'Customer',
  },
  ROUTINE: {
    value: 'ROUTINE',
    text: 'Routine',
  },
};

export const RETURN_METHOD = {
  PICKUP: {
    value: 'PICKUP',
    text: 'ordersExchange.pickup',
  },
  DROP_OFF: {
    value: 'DROP_OFF',
    text: 'ordersExchange.dropOff',
  },
};

export const EXCHANGE_CHANNEL = {
  ONLINE: {
    value: 'ONLINE',
    label: 'Online',
  },
  OFFLINE: {
    value: 'OFFLINE',
    label: 'Offline',
  },
};

export const PAYMENT_STATUS_CONST = {
  pending: {
    value: 'pending',
    text: 'Pending',
    color: '#E28800',
  },
  paid: {
    value: 'paid',
    text: 'Paid',
    color: '#27AE60',
  },
  fail: {
    value: 'fail',
    text: 'Fail',
    color: '#AB2328',
  },
  refund: {
    value: 'refund',
    text: 'Refund',
    color: '#AB2328',
  },
  waiting_for_refund: {
    value: 'waiting_for_refund',
    text: 'Waiting for refund',
    color: '#AB2328',
  },
  processing_refund: {
    value: 'processing_refund',
    text: 'Processing refund',
    color: '#AB2328',
  },
  refund_failed: {
    value: 'refund_failed',
    text: 'Refund failed',
    color: '#AB2328',
  },
};

export const EXCHANGE_REASON = {
  ITEM_MISSING: {
    value: 'ITEM_MISSING',
    text: 'ordersExchange.returnReason.missingItems',
  },
  INCORRECT_ITEM_SHIPPED: {
    value: 'INCORRECT_ITEM_SHIPPED',
    text: 'ordersExchange.returnReason.wrongItemsSent',
  },
  DIFFERENT_DESCRIPTION: {
    value: 'DIFFERENT_DESCRIPTION',
    text: 'ordersExchange.returnReason.productNotAsDescribed',
  },
  FUNCTIONAL_DMG: {
    value: 'FUNCTIONAL_DMG',
    text: 'ordersExchange.returnReason.productIsMalfunctionDirty',
  },
  EXCHANGE_SIZE: {
    value: 'EXCHANGE_SIZE',
    text: 'ordersExchange.returnReason.requestToExchangeSize',
  },
  DIFFERENT_MODEL: {
    value: 'DIFFERENT_MODEL',
    text: 'ordersExchange.returnReason.requestToExchangeForADifferentModel',
    fee: 35000,
  },
  // NO_NEED: {
  //   value: 'NO_NEED',
  //   text: 'ordersExchange.returnReason.noNeed',
  //   fee: 30000,
  // },
};

export const RETURN_SOLUTION = {
  REPLACE_ORDER: {
    value: 'REPLACE_ORDER',
    text: 'ordersExchange.solutions.replaceOrder',
  },
};

export const EXCHANGE_CANCEL_REASONS = {
  OVER_DUE_SUPPORT: {
    value: 'OVER_DUE_SUPPORT',
    text: 'ordersReturn.cancelReason.overDueSP',
  },
  PRODUCT_WRONG: {
    value: 'PRODUCT_WRONG',
    text: 'ordersReturn.cancelReason.productWrong',
  },
  PRODUCT_EXPIRY: {
    value: 'PRODUCT_EXPIRY',
    text: 'ordersReturn.cancelReason.productExpiry',
  },
  DISCOUNTED_OVER_30_PERCENT: {
    value: 'DISCOUNTED_OVER_30_PERCENT',
    text: 'ordersReturn.cancelReason.discountedPercent',
  },
  AGREEMENT_WITH_BUYER: {
    value: 'AGREEMENT_WITH_BUYER',
    text: 'ordersReturn.cancelReason.agreement',
  },
  UNCLEAR_REASON: {
    value: 'UNCLEAR_REASON',
    text: 'ordersReturn.cancelReason.unclearReason',
  },
  CORRECT_PRODUCT_SENT: {
    value: 'CORRECT_PRODUCT_SENT',
    text: 'ordersReturn.cancelReason.correctProduct',
  },
  OTHER: {
    value: 'OTHER',
    text: 'ordersReturn.cancelReason.other',
  },
};

export const EXCHANGE_CANCEL_REASONS_LIST = Object.values(
  EXCHANGE_CANCEL_REASONS,
);
